<template>
    <InertiaSquareConfirmActionButton
        :href="href"
        danger
        :title="$t('messages.delete')"
        :confirm-text="$t('messages.delete')"
        method="delete"
        :disabled="disabled"
        @finished="finished()"
    >
        <template v-slot:icon>
            <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                <path
                    fill-rule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                ></path>
            </svg>
        </template>

        {{ confirmMessage }}
    </InertiaSquareConfirmActionButton>
</template>
<script>
import InertiaSquareConfirmActionButton from '@/components/InertiaSquareConfirmActionButton.vue';

export default {
    emits: ['finished'],
    props: {
        href: {
            type: String,
            required: true,
        },
        confirmText: {
            type: String,
        },
        confirm: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        InertiaSquareConfirmActionButton,
    },
    data() {
        return {
            confirmMessage: this.confirmText ? this.confirmText : this.$t('messages.are_you_sure?'),
        };
    },
    methods: {
        finished() {
            this.$emit('finished');
        },
    },
};
</script>
